"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
function ContactUsSerializer(_a) {
    var { mark: { category }, children } = _a, extra = __rest(_a, ["mark", "children"]);
    return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, Object.assign({ to: ["/contact", category].filter(x => !!x).join("/") }, { children: children })));
}
exports.default = ContactUsSerializer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGFjdFVzU2VyaWFsaXplci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2hlbHAvc2FuaXR5L3NlcmlhbGl6ZXJzL0NvbnRhY3RVc1NlcmlhbGl6ZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7O0FBQ0EsdURBQXdDO0FBUXhDLFNBQXdCLG1CQUFtQixDQUFDLEVBSWpCO1FBSmlCLEVBQzFDLElBQUksRUFBRSxFQUFFLFFBQVEsRUFBRSxFQUNsQixRQUFRLE9BRWlCLEVBRHRCLEtBQUssY0FIa0Msb0JBSTNDLENBRFM7SUFFUixPQUFPLENBQ0wsdUJBQUMsdUJBQUksa0JBQUMsRUFBRSxFQUFFLENBQUMsVUFBVSxFQUFFLFFBQVEsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLGdCQUN4RCxRQUFRLElBQ0osQ0FDUixDQUFDO0FBQ0osQ0FBQztBQVZELHNDQVVDIn0=